export interface Entegrasyon {
  ad: string
  kategori: 'Ödeme' | 'İletişim' | 'Canlı yayın' | 'Muhasebe' | 'Kargo' | 'Kimlik' | 'Geliştirici'
  aciklama: string
  durum: 'hazir' | 'gelistiriliyor' | 'planlandi'
}

export const ENTEGRASYONLAR: Entegrasyon[] = [
  {
    ad: 'PayTR',
    kategori: 'Ödeme',
    aciklama: 'Kartla aidat, bağış ve bilet tahsilatı. Anahtar panelden, şifreli.',
    durum: 'hazir',
  },
  {
    ad: 'İyzico',
    kategori: 'Ödeme',
    aciklama: 'Kartla tahsilat ve taksit; imzalı geri bildirim doğrulaması.',
    durum: 'hazir',
  },
  {
    ad: 'Kuveyt Türk',
    kategori: 'Ödeme',
    aciklama: 'Katılım bankası sanal POS.',
    durum: 'gelistiriliyor',
  },
  { ad: 'Param', kategori: 'Ödeme', aciklama: 'Sanal POS ve cüzdan.', durum: 'planlandi' },
  {
    ad: 'Havale / EFT',
    kategori: 'Ödeme',
    aciklama: 'Sipariş numaralı açıklama ile otomatik eşleştirme.',
    durum: 'hazir',
  },
  {
    ad: 'Banka hesap hareketleri',
    kategori: 'Ödeme',
    aciklama: 'Günlük hareket çekimi ve üyeyle eşleştirme.',
    durum: 'planlandi',
  },
  {
    ad: 'Amazon SES',
    kategori: 'İletişim',
    aciklama: 'Toplu ve işlem e-postası; alan adı doğrulama, teslimat olayları.',
    durum: 'gelistiriliyor',
  },
  {
    ad: 'Netgsm',
    kategori: 'İletişim',
    aciklama: 'SMS, derneğin kendi hesabından; başlık ve anahtar panelden.',
    durum: 'gelistiriliyor',
  },
  {
    ad: 'WhatsApp Business',
    kategori: 'İletişim',
    aciklama: 'Onaylı şablonlarla hatırlatma ve bildirim.',
    durum: 'planlandi',
  },
  {
    ad: 'LiveKit',
    kategori: 'Canlı yayın',
    aciklama: 'Webinar ve online genel kurul; kayıt otomatik arşive.',
    durum: 'planlandi',
  },
  {
    ad: 'Zoom',
    kategori: 'Canlı yayın',
    aciklama: 'Mevcut Zoom hesabıyla ders; kayıt ve yoklama platforma.',
    durum: 'planlandi',
  },
  {
    ad: 'Paraşüt',
    kategori: 'Muhasebe',
    aciklama: 'Gelir-gider kayıtlarının aktarımı.',
    durum: 'planlandi',
  },
  {
    ad: 'Excel / CSV',
    kategori: 'Muhasebe',
    aciklama: 'Her listeyi içe ve dışa aktarma; mali müşavir düzeni.',
    durum: 'hazir',
  },
  {
    ad: 'Geliver',
    kategori: 'Kargo',
    aciklama: 'Mağaza siparişlerinde kargo etiketi ve takip.',
    durum: 'planlandi',
  },
  {
    ad: 'Tek oturum açma (SSO)',
    kategori: 'Kimlik',
    aciklama: 'Kurumsal planda kimlik sağlayıcınızla giriş.',
    durum: 'planlandi',
  },
  {
    ad: 'API ve webhook',
    kategori: 'Geliştirici',
    aciklama: 'Açık OpenAPI şeması; olaylarda webhook. Pro ve üzeri.',
    durum: 'gelistiriliyor',
  },
]
